import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion/dist/index';
import { appMainBackground, mediumGrey } from '../../../styles/colors';
import { clearMobileLoginSessionData, shouldPreserveMobileLoginSessionData } from '../services/sso-helpers';
import { ssoLoginActions, ssoLoginSelectors } from '../reducer/sso-login-reducer';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import EndInteraction from '../../app/components/EndInteraction';

const SsoLoginDiv = styled.div(() => {
  let style = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appMainBackground
  };
  return style;
});

const SsoLoginBox = styled.div(() => {
  let style = {
    color: mediumGrey,
    textAlign: 'center',
    width: '480px'
  };
  return style;
});
const LoginHeader = styled.div(() => {
  let style = {
    fontSize: '48px',
    fontWeight: '200',
    lineHeight: '50px',
    marginBottom: '30px'
  };
  return style;
});

const LoginText = styled.div(() => {
  let style = {
    marginRight: '20px',
    marginLeft: '20px',
    fontSize: '22px',
    lineHeight: '35px'
  };
  return style;
});

/*
    SsoLogin page gets all the data it needs from the location.

    It tries to fetch the samlEntityId based on the clientId query param,
    which is the org's global_unique_id, and then redirect to tully.

    The only time this page will render is if something goes wrong with
    the process of getting the samlEntityId and redirecting.
 */
//*********************************************
export class SsoLogin extends PureComponent {
  componentWillMount = () => {
    // clear the mobile-login cookie just in case it's left over from some past event
    if (!shouldPreserveMobileLoginSessionData(this.props.location)) {
      clearMobileLoginSessionData();
    }
    this.props.attemptSsoLogin(this.props.location);
  };

  render = () => {
    // while attempting to login, show the spinner
    if (this.props.ssoLoginAttemptPending) {
      return <MouseCatcher />;
    }

    if (!this.props.lionLoaded) {
      return null;
    }

    // if we tried and failed show the error
    if (!this.props.orgSamlEntityId) {
      return (
        <SsoLoginDiv data-qa="SsoLoginFailed">
          {/* event will be sent after user authenticates */}
          <EndInteraction interaction="application-startup" />
          <SsoLoginBox>
            <LoginHeader>{this.props.lionTranslateString('_account_error')}</LoginHeader>
            <LoginText>{this.props.lionTranslateString('_contact_org_admin')}</LoginText>
          </SsoLoginBox>
        </SsoLoginDiv>
      );
    }

    return null;
  };
}

SsoLogin.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  orgSamlEntityId: ssoLoginSelectors.orgSamlEntityId(state),
  ssoLoginAttemptPending: ssoLoginSelectors.ssoLoginAttemptPending(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = { attemptSsoLogin: ssoLoginActions.attemptSsoLogin };
export const SsoLoginContainer = connect(
  mapStateToProps,
  wrapActions
)(SsoLogin);



// WEBPACK FOOTER //
// ./src/modules/login/components/SsoLogin.jsx